export const backgroundColor = props => {
  let color = props.color || "primary"
  if (props.ghost) {
    color = "transparent"
  }

  if (
    props.disabled &&
    (props.color === "primary" ||
      props.color === "landingRed" ||
      props.color === "landingBlue")
  ) {
    color = props.color + "Light"
  }

  return props.theme.colors[color]
}

export const hoverColor = props => {
  let color = props.hoverColor || "primaryDark"
  if (props.ghost) {
    color = props.color || "primary"
  } else if (props.color === "landingRed") {
    color = "landingRedDark"
  } else if (props.color === "landingBlue") {
    color = "landingBlueDark"
  }

  if (
    props.disabled &&
    (props.color === "primary" ||
      props.color === "landingRed" ||
      props.color === "landingBlue")
  ) {
    color = props.color + "Light"
  }

  return props.theme.colors[color]
}

export const textColor = props => {
  let color = props.textColor || "white"
  if (props.ghost) {
    color = props.color
  }
  return props.theme.colors[color]
}

export const hoverTextColor = props => {
  let color = props.hoverTextColor || "white"
  return props.theme.colors[color]
}

export const borderColor = props => {
  let color = props.borderColor || props.color || "primary"

  if (
    props.disabled &&
    (props.color === "primary" ||
      props.color === "landingRed" ||
      props.color === "landingBlue")
  ) {
    color = props.color + "Light"
  }

  return props.theme.colors[color]
}

export const hoverBorderColor = hoverColor



// WEBPACK FOOTER //
// ./src/components/Button/style.js